import Banner from "./components/Banner";
// import Search from "./components/search";
import List from "./components/list";
import Links from "./components/links";
import TopGainers from "./components/topGainers";
import "./assets/styles/main.scss";
import "./assets/styles/custom.scss";

function App() {
  return (
    <div>
      <Banner />
      <Links />
      {/* <Search /> */}
      <TopGainers />
      <hr />
      <List />
    </div>
  );
}

export default App;
